export const AssessmentTitle = ({assessment, visible=true}) => {
    console.log("assessment in title:", assessment);
    return (
        <div className="vertical quiz-title-view standard-margin-bottom" style={{height:"max-content", width:"100%"}}>

            <h4 className="assesment-title">
                {assessment?.title}
            </h4>
 
        {visible === true && <h5 className="primary-600 assesment-description">
                {assessment?.description}
            </h5> }
       
        </div>

    )
}